import { useEffect, useState } from 'react'
import { supabase } from '../supabase'

export const REPORTING_CURRENCIES = ['GBP', 'EUR', 'USD', 'AUD', 'CAD']

export function useReportingCurrency(orgId) {
  const [reportingCurrency, setReportingCurrency] = useState('GBP')
  const [rateSnapshot, setRateSnapshot] = useState(null)

  useEffect(() => {
    if (!orgId) return undefined
    let active = true
    const storageKey = `delivr.reporting-currency.${orgId}`
    const storedCurrency = window.localStorage.getItem(storageKey)
    setReportingCurrency(REPORTING_CURRENCIES.includes(storedCurrency) ? storedCurrency : 'GBP')
    setRateSnapshot(null)

    async function loadRates() {
      const { data } = await supabase.from('exchange_rate_snapshots').select('base_currency, rates, rate_date, fetched_at').order('fetched_at', { ascending: false }).limit(1).maybeSingle()
      if (!active) return
      if (data) setRateSnapshot(data)
      const fetchedAt = data?.fetched_at ? new Date(data.fetched_at).getTime() : 0
      if (data && Date.now() - fetchedAt < 12 * 60 * 60 * 1000) return
      const { data: refreshed } = await supabase.functions.invoke('refresh-exchange-rates')
      if (active && refreshed?.rates) setRateSnapshot(refreshed)
    }

    loadRates()
    return () => { active = false }
  }, [orgId])

  function changeReportingCurrency(currency) {
    if (!REPORTING_CURRENCIES.includes(currency)) return
    setReportingCurrency(currency)
    if (orgId) window.localStorage.setItem(`delivr.reporting-currency.${orgId}`, currency)
  }

  return { reportingCurrency, rateSnapshot, changeReportingCurrency }
}
